// ===================================================================
// CONFIGURAÇÃO DE MODO DE MANUTENÇÃO
// ===================================================================

// MODO 1: Manutenção GLOBAL (todo o portal)
// - true: TODO o portal fica em manutenção para TODOS os usuários
// - false: Portal funciona normalmente (exceto geradores específicos abaixo)
export const MAINTENANCE_MODE = false;

// MODO 2: Manutenção SELETIVA por Gerador
// - Array de generator_ids que devem ficar em manutenção
// - Se vazio [], nenhum gerador específico fica em manutenção
// - Funciona independente de MAINTENANCE_MODE estar true ou false
// - Para adicionar: inclua o generator_id no array
// - Para remover: remova o generator_id do array
export const MAINTENANCE_GENERATORS: string[] = [
];

// Mensagens personalizadas
export const MAINTENANCE_TITLE = 'Portal temporariamente fora do ar';
export const MAINTENANCE_DESCRIPTION = 'Estamos realizando correções e voltaremos em breve.';

// ===================================================================
// FUNÇÕES HELPER
// ===================================================================

/**
 * Verifica se um gerador específico está em modo de manutenção
 */
export const isGeneratorInMaintenance = (generatorId: string | null | undefined): boolean => {
  if (!generatorId) return false;
  return MAINTENANCE_GENERATORS.includes(generatorId);
};

/**
 * Verifica se o portal está em modo de manutenção (global ou para um gerador específico)
 */
export const isInMaintenanceMode = (generatorId?: string | null): boolean => {
  // Se modo global está ativo, todos ficam em manutenção
  if (MAINTENANCE_MODE) return true;
  
  // Se não, verifica se o gerador específico está em manutenção
  if (generatorId) {
    return isGeneratorInMaintenance(generatorId);
  }
  
  return false;
};
